import React, { useMemo } from 'react';
import './MainPage.css';

const MainPage: React.FC = () => {
  // Extract server name from URL (hostname)
  const serverName = useMemo(() => {
    return window.location.hostname || 'Server';
  }, []);

  return (
    <div className="main-page" role="main">
      <h1 className="main-hostname">{serverName}</h1>
    </div>
  );
};

export default MainPage;
